import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Col } from 'reactstrap'
import {
  ContainerLg,
  H5,
  Paragraph,
  Panel,
  Section,
  RowCentered
} from '../../../GlobalStyles'
import { IconLink, TextLink } from '../../../common/Links'
import styled from 'styled-components'
import theme from '../../../theme'
import { appleStore, googlePlay } from '../../../common/Svg/elements'
import Svg from '../../../common/Svg'
import { myPgaIOSUrl, myPgaAndroidUrl } from '../../../../constants'

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin-top: 32px;
`

const TilesBody = styled.div`
  padding: 32px 32px;
`

const FeaturesSet = props => (
  <StaticQuery
    query={graphql`
      query {
        coachAppImage: file(
          relativePath: { eq: "CoachResources/20190724_PGA_kr_024.jpg" }
        ) {
          ...optimizedImage
        }
        parentInfo: file(
          relativePath: { eq: "CoachResources/GettyImages-1059122334.jpg" }
        ) {
          ...optimizedImage
        }
      }
    `}
    render={data => (
      <Section
        bgColor={theme.colors.lightenGray}
        size='0 0 100px'
        id='features'
      >
        <ContainerLg>
          <RowCentered>
            <Col xl='4' md='6'>
              <Panel>
                <Img fluid={data.coachAppImage.childImageSharp.fluid} />
                <TilesBody>
                  <H5 color={theme.colors.navy}>PGA COACH App</H5>
                  <Paragraph>
                    Through the PGA Coach App, PGA and LPGA Members can get
                    access to activity planning, note-taking and assessment
                    tools that make it easy to quickly start applying ADM
                    principles.
                  </Paragraph>
                  <ButtonsContainer>
                    <TextLink
                      color={theme.colors.black}
                      hoverColor={theme.colors.darkGray}
                      url={myPgaIOSUrl}
                    >
                      <Svg d={appleStore} width={125} height={36} />
                    </TextLink>
                    <TextLink
                      color={theme.colors.black}
                      hoverColor={theme.colors.darkGray}
                      url={myPgaAndroidUrl}
                    >
                      <Svg d={googlePlay} width={125} height={36} />
                    </TextLink>
                  </ButtonsContainer>
                </TilesBody>
              </Panel>
            </Col>
            <Col xl='4' md='6'>
              <Panel>
                <Img fluid={data.parentInfo.childImageSharp.fluid} />
                <TilesBody>
                  <H5 color={theme.colors.navy}>Parent Info</H5>
                  <Paragraph>
                    PGA Coach strives to provide our Members with the resources
                    they need to properly inform parents about the benefits of
                    the ADM principles by stage, age and physical/social
                    development.
                  </Paragraph>
                  <IconLink
                    url='/coach-parents/'
                    aria-label='READ NOW'
                    padding='16px 0'
                    color={theme.colors.black}
                    hoverColor={theme.colors.darkGray}
                  >
                    READ NOW
                  </IconLink>
                </TilesBody>
              </Panel>
            </Col>
          </RowCentered>
        </ContainerLg>
      </Section>
    )}
  />
)

export default FeaturesSet
